/* eslint-disable import/extensions */
import React, { useState } from 'react';
import {
  MapContainer,
} from 'react-leaflet';
import 'leaflet/dist/leaflet.css';
import L, { LatLngBoundsExpression } from 'leaflet';
import './map.scss';
import {
  NetworkTopologyMapData
} from 'data/network-topology/network-topology.types';
import ClusterGroupWrapper from './ClusterGroupWrapper';
import MapControl from './MapControl';

interface IMapState {
  mapConfig?: any;
  mapData: NetworkTopologyMapData;
  selectedBaseMap: any;
  zoomInLocarion?: { latitude: number, longitude: number, zoom: number }
  setClusterExpansionList: any;
}

const basemaps: any = {};

const Map = ({
  mapConfig, selectedBaseMap, mapData, zoomInLocarion, setClusterExpansionList
}: IMapState) => {

  const center = {
    lat: mapConfig.mapPosition.center[0],
    lng: mapConfig.mapPosition.center[1]
  };
  const { zoom } = mapConfig.mapPosition;
  const { maxZoom } = mapConfig.mapPosition;
  const [tilesLoaded, setTilesLoaded] = useState<boolean>(false);
  const bounds = [
    [-90, -180],
    [90, 180]
  ] as LatLngBoundsExpression;

  const renderClusterGroups = (setClusterExpansionList: any) => {
    return (
      <React.Fragment>
        <ClusterGroupWrapper mapData={mapData} setClusterExpansionList={setClusterExpansionList} />
      </React.Fragment>
    );
  };

  const onTileLayerLoad = () => {
    setTilesLoaded(true);
  }

  return (
    <MapContainer
      className="leaflet-map"
      center={center}
      zoom={zoom}
      // scrollWheelZoom={false}
      maxBounds={bounds}
      maxZoom={maxZoom}
      minZoom={zoom}
      // ref={mapRef}
      // scrollWheelZoom={false}
      zoomControl={false}
      scrollWheelZoom
      doubleClickZoom={false}
      // wheelDebounceTime={500}
      // wheelPxPerZoomLevel={500}
      whenCreated={(map) => {
        const tileLayer = L.tileLayer(selectedBaseMap);
        tileLayer.on('load', onTileLayerLoad);
        tileLayer.addTo(map);
      }}
    >
      {/* <TileLayer url="https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}{r}.png" /> */}
      {tilesLoaded && renderClusterGroups(setClusterExpansionList)}
      {tilesLoaded && <MapControl defaultZoom={zoom} center={center as L.LatLng} zoomInLocarion={zoomInLocarion} />}

    </MapContainer>
  );
};

export default Map;
